import React from "react";
import PageHeader from "../../PageHeader";
import AddAddScoreSchemeForm from "./AddAddScoreSchemeForm";
import { ReactComponent as SectionIcon } from "../../../images/sectionimage/Section.svg";
import { ReactComponent as BackIcon } from "../../../images/pageheadingicon/backicon.svg";
import useStyles from "../../../../styles";

function AddScoreScheme() {
  const classes = useStyles();
  const Heading = [
    {
      id: 1,
      pageicon: <SectionIcon />,
      mainheading: "Add Scheme",
      // subhead: "Want to Add in Bulk ? ?",
      // downloadlink: "Download bulk Sample Files",
      addbtntext: "Back",
      addbtnicon: <BackIcon />,
      addbtnstyle: "transparentbtn",
      path: "/admin/scorescheme",
    },
  ];
  return (
    <div className={`${classes.p2} ${classes.pb0}`}>
      <PageHeader Heading={Heading} />
      <AddAddScoreSchemeForm />
    </div>
  );
}
export default AddScoreScheme;
